class MixedCheckboxGroup extends CheckboxGroup {
    constructor(checkboxGroupName: string, checkboxElements: JQuery[], checkboxLabels: string[], controller: Controller, mode: string) {
        super(checkboxGroupName, controller, mode);

        this.initCheckboxes(checkboxElements, checkboxLabels);
    }

    initCheckboxes(oldElements: JQuery[], labels: string[]) {
        for(let i = 0; i < oldElements.length; i++) {
            var newCheckbox = new MixedCheckbox(labels[i], this.controller, oldElements[i], this, this.mode);
            this.children[newCheckbox.identifier] = newCheckbox;
        }
    }
}